<template>
  <div class="mb-3">
    <label class="d-block">{{ $tc("custom_forms.region_field") }}</label>
    <v-select
      :options="regions"
      v-model="selectedState"
      :placeholder="$t('custom_forms.region_field')"
      class="w-100"
      label="state"
      :clearable="false"
    />
    <div class="d-flex flex-row mt-1 align-items-end ">
      <b-form-group :label="$t('custom_forms.types.keyword')" label-for="option-name" class="w-50 m-0">
        <b-form-input
          id="option-name"
          v-model.trim="selectedState.keyword"
          required
          disabled
        />
      </b-form-group>
      <b-button
        @click="generateRandomKeyword"
        :disabled="!selectedState.wordsOptions.length"
        variant="primary"
        size="small"
        class="ml-1">
        {{ $t('custom_forms.generate_keyword') }}
      </b-button>
    </div>
    <div class="d-flex flex-row align-items-end mt-1">
      <b-form-group :label="$t('risk.template.option_name')" label-for="option-name" class="w-50 m-0">
        <b-form-input
          id="option-name"
          v-model.trim="optionName"
          required
          :disabled="!selectedState.state"
        />
      </b-form-group>
      <b-button
        variant="primary"
        size="small"
        class="ml-1"
        @click="addOption"
        :disabled="!selectedState.state">
        {{ $t('risk.template.add_option') }}
      </b-button>
    </div>

    <div class="mt-1">
      <h5>{{ $t('risk.template.added_options') }}</h5>

      <b-table small :items="selectedState.wordsOptions" :fields="fields" responsive>
        <template #cell()="{ item }">
          <span style="text-transform: none !important">{{ item }}</span>
        </template>

        <template #cell(actions)="{ index }">
          <b-button size="sm" variant="danger" @click="removeOption(index)">
            {{ $t('actions.delete') }}
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import OptionConfig from './OptionConfig.vue';
import vSelect from "vue-select";

const MEXICO_STATES = [
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Ciudad de México',
  'Coahuila',
  'Colima',
  'Durango',
  'Guanajuato',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'Estado de México',
  'Michoacán',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Querétaro',
  'Quintana Roo',
  'San Luis Potosí',
  'Sinaloa',
  'Sonora',
  'Tabasco',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz',
  'Yucatán',
  'Zacatecas'
]

export default {
  components: {
    OptionConfig,
    vSelect
  },
  props: {
    data: Object,
    config: Object,
  },
  data() {
    return {
      optionName: '',
      selectedState: {
        state: '',
        wordsOptions: [],
        keyword: '',
      },

      regions: [],

      fields: [
        { key: 'keyword', label: 'Keyword' },
        { key: 'actions', label: this.$tc('actions.name', 1) },
      ],

      numberOfWords: 1,
    }
  },
  created() {
    this.regions = MEXICO_STATES.map(state => ({
      state,
      wordsOptions: [],
      keyword: '',
    }))
    if (this.data?.data?.length > 5) {
      this.regions = this.data.data
      this.selectedState = this.regions[0]
    }
  }, 
  methods: {
    getCurrentRegion() {
      return this.regions.find(r => r.state === this.selectedState.state)
    },

    addOption() {
      if (!this.optionName || !this.selectedState) return

      const region = this.getCurrentRegion()
      region.wordsOptions.push(this.optionName)

      this.optionName = ''
      this.updateData()
    },

    removeOption(wordIndex) {
      const region = this.getCurrentRegion()
      region.wordsOptions.splice(wordIndex, 1)
      this.updateData()
    },

    generateRandomKeyword() {
      const region = this.getCurrentRegion()
      if (!region.wordsOptions.length) {
        region.keyword = ''
        return
      }

      const shuffled = [...region.wordsOptions].sort(() => 0.5 - Math.random())
      region.keyword = shuffled
        .slice(0, this.numberOfWords)
        .join(' ')

      this.updateData()
    },

    updateData() {
      this.$emit('update:data', {
        data: this.regions
      })
    },
  }
};
</script>

<style scoped>
</style>
